import React from 'react'

export const CommentIcon = ({
  fill = 'none',
  width = '20',
  height = '20',
  stroke = '#000000',
  strokeGradient = []
}) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    width={width}
    height={height}
    cursor="pointer"
  >
    {
      strokeGradient.length
        ? (
          <defs>
            <linearGradient
              id="gradient"
              x1="60%"
              x2="40%"
              y1="50%"
              y2="70%"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset="0%"
                stopColor={strokeGradient[0]}
              />
              <stop
                offset="100%"
                stopColor={strokeGradient[1]}
              />
            </linearGradient>
          </defs>
        ) : ''
    }

    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <path
        stroke={stroke === 'gradient' ? 'url(#gradient)' : stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7 8h10M7 11h10M7 14h4m-8 4V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7.667a2 2 0 0 0-1.2.4L3 21v-3z"
      />
    </g>
  </svg>
)
